<template>
  <v-container fluid fill-height grid-list-md pt-0 style="padding-bottom: 50px">
    <v-layout column>
    <v-toolbar
      color="#eee"
      class="elevation-0 secondary--text"
      style="background: transparent"
      >
        <v-select
          v-model="selectedReport"
          :items="reports"
          label="Selecione um relatório para visualizar"
          item-text="nome"
          item-value="path"
          solo
          autofocus
        ></v-select>
    </v-toolbar>
    <router-view></router-view>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  data () {
    return {
      reports: [
        {
          nome: 'Relatório de vendas',
          path: '/relatorio/compras'
        },
        {
          nome: 'Vouchers lidos',
          path: '/relatorio/vouchers'
        },
        {
          nome: 'Relatório de Prêmios',
          path: '/relatorio/premiacoes'
        },
        {
          nome: 'Relatório de vendas de CashPosto',
          path: '/relatorio/compras-de-cashposto'
        },
        {
          nome: 'Relatório de Cash',
          path: '/relatorio/cash'
        },
        {
          nome: 'Relatório de Convênio',
          path: '/relatorio/convenio'
        },
        {
          nome: 'Relatório vouchers empresas',
          path: '/relatorio/vouchers-empresas'
        },
        {
          nome: 'Relatório PIX',
          path: '/relatorio/relatoriopix'
        },
        {
          nome: 'Relatório de Dívidas CashPosto',
          path: '/relatorio/dividas-cashposto'
        },
        {
          nome: 'Relatório de Vendas de Assinatura',
          path: '/relatorio/vendas-de-assinatura'
        }
      ],
      selectedReport: null
    }
  },
  watch: {
    selectedReport (val) {
      if (val !== null && val !== undefined) {
        this.$router.push(val)
      }
    },
    '$route' (val) {
      if (val.path === '/relatorio') {
        this.selectedReport = this.reports[0].path
        this.$router.push(this.reports[0].path)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.selectedReport) {
        this.selectedReport = this.reports[0].path
      }
    })
  }
}
</script>
